import { ColorSchemeScript, MantineProvider } from "@mantine/core";
import { StrictMode } from "react";
import { Outlet } from "react-router-dom";
import { DemoModalProvider } from "$/components/demo-modal";
import { ImageLightboxProvider } from "$/components/image-lightbox";
import { Footer } from "$/sections/footer";
import { Navbar } from "$/sections/navbar";
import { theme } from "$/theme";

export default function Layout() {
  return (
    <StrictMode>
      <ColorSchemeScript forceColorScheme="light" />
      <MantineProvider theme={theme} forceColorScheme="light">
        <DemoModalProvider>
          <ImageLightboxProvider>
            <Navbar />
            <main>
              <Outlet />
            </main>
            <Footer />
          </ImageLightboxProvider>
        </DemoModalProvider>
      </MantineProvider>
    </StrictMode>
  );
}
